import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { setAppointmentField, validateAppointmentField, submitAppointment, toggleAppointmentField} from './Actions/Appointments.action';
import {getSchedulers, setTimeLineField} from 'js/Actions/TimeLine.action';
import {setStep} from './Actions/Steps.action';
import {  Footer } from './Containers/Footer.container';
import ShopName from './Containers/ShopName.container';
import {SubmitContainer} from 'js/Containers/Submit.Container';
import {ConfirmationContainer} from './Containers/Confirmation.container';
import {BookAppointPopup} from './Containers/BookAppointPopup.container';
import {BreadCrumb} from './Components/BreadCrumb';
import {ProductStep} from './Containers/Product.Step';
import TimelineStep from './Containers/TimeLine.Step';
import {closeAlert} from 'js/Actions/AlertMessage.action';
import {AlertMessage} from 'js/Components/AlertMessage';
import {gaInit, gaEvent} from 'js/Core/ga';
import {clearInfoUser, roundDuration, countDurationSelected} from 'js/Core/utils';
import {customFormatDate} from 'js/Core/date';

const mapStateToProps = state => {
    return {
			appointments : state.appointments,
			shopName: state.shop,
			products: state.products,
			errors: state.errors,
			steps: state.steps,
			person: state.person,
			timelines: state.timelines,
			retailer: state.retailer,
			shopAlertMessage: state.shopAlertMessage,
			fieldsDefination: state.fieldsDefination
    }
}

const mapDispatchToProps = dispatch => {
    return {
		setAppointmentField: (list) => dispatch(setAppointmentField(list)),
		toggleAppointmentField: (list) => dispatch(toggleAppointmentField(list)),
		validateAppointmentField : () => dispatch(validateAppointmentField()),
		submitAppointment: () => dispatch(submitAppointment()),
		getSchedulers: ()=>dispatch(getSchedulers()),
		setTimeLineField: (list) => dispatch(setTimeLineField(list)),
		setStep: (step) => dispatch(setStep(step)),
		closeAlert: () => dispatch(closeAlert())
    }
}

class AppContainers extends Component {
    constructor(props) {
		super(props);
		[
			'handleChangeSubscribe',
			'handleCancel',
			'handleValidate',
			'handleSubmitAppoint',
			'clickOutSidePopup',
			'closePopup',
			'handleSelectproduct',
			'backToProduct',
			'removeProduct',
			'handleCloseAlert'
		].forEach(fn => this[fn] = this[fn].bind(this));
	}
	handleChangeSubscribe(e){
		let {value} = e.target,
			{bookerInfo} = this.props.appointments;
		this.props.setAppointmentField([
			{key: 'bookerInfo',value: {...bookerInfo, emailSubscribe: value}}
		]);
	}
	handleCancel(){

		let {setStep, setAppointmentField} = this.props;
		setStep && setStep(2);
		setAppointmentField([{key: 'validateAppointment', value: false}]);

		setTimeout(() => {
			let elIdError = document.getElementById('list-products-selected');    
			if(elIdError){
					let topOff = elIdError.getBoundingClientRect().top + window.scrollY - 100;
					window.scrollTo(0,topOff)
			}
		},100)
	}
	handleValidate(){	
		let infoData = localStorage.getItem('infoData') ? JSON.parse(localStorage.getItem('infoData')) : null;
		if(infoData){

			let {bookerInfo} = this.props.appointments;
			this.props.setAppointmentField([
				{
					key: 'bookerInfo',
					value: {
						...bookerInfo,
						customerName: infoData.customerName ? infoData.customerName : '',
						fullName: infoData.fullName ? infoData.fullName : '',
						phoneNumber: infoData.phoneNumber ? infoData.phoneNumber : '',
						email: infoData.email ? infoData.email : '',
						birthDate: infoData.birthDate ? infoData.birthDate : '',
						sex: infoData.sex ? infoData.sex : '女性',
						age: infoData.age ? infoData.age : ''
					}
				}
			])
		}	
		this.props.validateAppointmentField();
	}
	handleSubmitAppoint(){
		if(this.props.appointments.validateAppointment){
			let elFooter = document.getElementsByClassName('form-submit')[0];
        	elFooter.classList.add('prevent_loop_submit');
			this.props.submitAppointment();
		}		
	}
	closePopup(){
		if(this.props.appointments.statusSubmit === 'SUCCESS'){
			let {urlRedirect} = this.props.shopName;
			localStorage.removeItem('idProduct');
			if(urlRedirect !== ''){
				window.location.href = urlRedirect;
			}else{
				window.location.reload();

			}
		}else{
			if(this.props.appointments.statusSubmit === 'NO PRODUCT'){
				let bodyEl = document.getElementsByTagName('html')[0];
        		bodyEl.className  = '';
				this.props.setAppointmentField([{key: 'statusSubmit', value: ''}]);
			}else{
				window.location.reload();
			}

		}

		
	}
	clickOutSidePopup(e){
		let {target} = e,
			child = document.getElementsByClassName('popup'),
			checkHasClass = false,
			targetChildren = target.children;

		for(let i = 0 ; i< targetChildren.length;i++){
			if(targetChildren[i].classList.contains('popup')){
				checkHasClass = true;
			}
		}
		if(target !== child && checkHasClass){
			this.closePopup();
		}
	}
	backToProduct(){
		this.props.setStep && this.props.setStep(1);
	}
	// roundDuration(time = 0){
	// 	let {timeBlock} = this.props.shopName;
	// 	if(time % timeBlock > 0){
	// 		time = (time - (time % timeBlock))  + timeBlock;
	// 	}	
	// 	return time
	// }
	handleSelectproduct(idProduct, selected){
		const {appointments ,toggleAppointmentField, setTimeLineField, products, getSchedulers, setAppointmentField, setStep, timelines, shopName} = this.props;
		//const selectedProducts = products.find(product=>idProduct === product.id);		
		//const durationSelected = this.roundDuration(selectedProducts.duration);
		//const serviceDuration = !selected ? timelines.serviceDuration + selectedProducts.duration : timelines.serviceDuration - selectedProducts.duration;		
		//const totalDuration = roundDuration(serviceDuration, shopName.timeBlock);
		let listSelected = [];
		////////////////////////////
		if(selected){
			listSelected = [...appointments.selectedProducts].filter(id => id !== idProduct);
		}else{
			listSelected = [...appointments.selectedProducts, idProduct];
		}

		let totalNotRound = countDurationSelected(listSelected, products)
		let totalDuration = roundDuration(totalNotRound, shopName.timeBlock);
		/////////////////////////////////
		window.scroll(0,0); // scroll to top after selecte product
		setAppointmentField([
            {key: 'selectedTimeline', value: {from: null, to: null}},
			{key: 'selectedCalendar', value: customFormatDate(new Date())},
			{key: 'selectedProducts', value: listSelected}
        ]);
		//toggleAppointmentField && toggleAppointmentField({key: 'selectedProducts', value: idProduct});	
		setTimeLineField && setTimeLineField([{key: 'serviceDuration', value: totalDuration}])	
        if(!selected){
			setStep && setStep(2);
			getSchedulers()
		}else{
			let len = appointments.selectedProducts.length;
			if(len - 1 > 0){
				setStep && setStep(2);
				getSchedulers()
			}			
		}
	}
	removeProduct(idProduct){
		const {appointments ,toggleAppointmentField, getSchedulers, setTimeLineField, products, setAppointmentField, setStep, timelines, shopName} = this.props;
		//const selectedProducts = products.find(product=>idProduct === product.id);
		//const durationSelected = this.roundDuration(selectedProducts.duration);
		//const serviceDuration = timelines.serviceDuration - selectedProducts.duration;
		//const totalDuration = roundDuration(serviceDuration, shopName.timeBlock);

		let listSelected = [...appointments.selectedProducts].filter(id => id !== idProduct);
		////////////////////////////

		let totalNotRound = countDurationSelected(listSelected, products)
		let totalDuration = roundDuration(totalNotRound, shopName.timeBlock);

		/////////////////////////////////

		//toggleAppointmentField && toggleAppointmentField({key: 'selectedProducts', value: idProduct});		
		setTimeLineField && setTimeLineField([
			{key: 'serviceDuration', value: totalDuration},			
		]);
		setAppointmentField([{key: 'selectedProducts', value: listSelected}])
		
		//let len = appointments.selectedProducts.length;
		if(listSelected.length < 1){
			setStep && setStep(1);
		}else{
			setAppointmentField([
				{key: 'selectedTimeline', value: {from: null, to: null}},
				{key: 'selectedCalendar', value: customFormatDate(new Date())}
			]);
			setAppointmentField
			let blockSelected = document.getElementsByClassName('block-selected');
			if(blockSelected.length > 0){
				blockSelected[0].classList.remove('block-selected');
			}			
			getSchedulers()
		}
	}
	handleCloseAlert(){
		this.props.closeAlert();
	}
	componentWillMount(){
		if(localStorage.getItem('idProduct')){
			localStorage.removeItem('idProduct')
		}
		clearInfoUser();
	}
	componentDidMount(){
		let listSelected = localStorage.getItem('selectedProduct');
		if(listSelected){
			localStorage.removeItem('selectedProduct')
		}
		gaInit('/SunSale', this.props.shopName.id);		

		let firstLoadGa = localStorage.getItem('firstLoadGa') ? JSON.parse(localStorage.getItem('firstLoadGa')) : '';
		if(firstLoadGa === ''){
			gaEvent('SunSale', 'View store', 'SunSale - ' + this.props.shopName.id);			
		}		
		localStorage.removeItem('firstLoadGa');

		window.onpageshow = function(event) {
			setTimeout(() => {
				let appContainers = document.getElementById('appContainer');
				appContainers.scrollIntoView();
			},100);
		};
		
	}
  render() {
		const {shopName, products, appointments, retailer, shopAlertMessage, fieldsDefination} = this.props,
			{validateAppointment} = appointments;
		const customsProps = {
			...this.props,
			validateAppointment, 
			handleBack: this.handleCancel, 
			handleValidate: this.handleValidate, 
			handleSubmitAppoint:  this.handleSubmitAppoint
		};
		const confirmProps = {
			...appointments,
			products,
			steps: this.props.steps,
			shopName: retailer.name !== '' ? retailer : shopName,
			fieldsDefination
		}
		const popupProps = {
			statusSubmit: appointments.statusSubmit,
			clickOutSidePopup: this.clickOutSidePopup,
			closePopup: this.closePopup,
		}
		const productProps ={
            products: this.props.products,
			handleSelectproduct: this.handleSelectproduct,
			selectedProducts: this.props.appointments.selectedProducts,
			steps: this.props.steps
		}
		const timelineProps = {
			steps: this.props.steps,
			handleChangeSubscribe: this.handleChangeSubscribe,
			products: this.props.products,
			selectedProducts: this.props.appointments.selectedProducts,
			backToProduct: this.backToProduct,
			removeProduct: this.removeProduct,
			shopName: retailer.name !== '' ? retailer : shopName
		}
		return (
			<Fragment>
				<div className="container"  >
					<div className="container-header"> <div className="logo"> </div> </div>
					<div className="container-body"  >
						<ShopName shopName={shopName}/>						
						<div className="page-body">
							<div className="page-body__main clearfix">
							
								<BreadCrumb step={this.props.steps.currentStep} backToProduct={this.backToProduct}/>
								<ProductStep {...productProps}/>
								<TimelineStep {...timelineProps}/>
								<ConfirmationContainer {...confirmProps} />
								{
									this.props.steps.currentStep > 1 ? 
									<Fragment><SubmitContainer {...customsProps} /> <Footer /> </Fragment>: ''
								}
								
							</div>
						</div>
					</div>
				</div>
				{
					appointments.statusSubmit !== '' ? <BookAppointPopup {...popupProps}/> : ''
				}
				{
					shopAlertMessage && shopAlertMessage !== '' ? <AlertMessage txt = {shopAlertMessage} handleCloseAlert={this.handleCloseAlert}/> : ''
 				}
			</Fragment>
		)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AppContainers);
